// Items initialized on page loaded
import initLookbook from '@sectionsJS/lookbook';

// $(async () => {

// });

// Need to wait for third party code to be loaded (_swat object)
$(window).on('load', async () => {
  initLookbook();
});
